import { gql } from 'apollo-angular'

export const GET_AUTHOR_FILTER_ITEMS = gql`
  query getAuthorFilterItems {
    Authors(limit: -1) {
      docs {
        id
        name
      }
    }
  }
`
